export const environment = {
  production: false,
  // bpp (backend) endpoints
  bppBackend: 'https://bpp.dev.go-plattform.at',
  // legacy  endpoints
  featureToggles: {
    showCalculationPremiumEnabled: true
  }
};
